import { render } from "./TheAbout.vue?vue&type=template&id=6f432c86&scoped=true"
const script = {}

import "./TheAbout.vue?vue&type=style&index=0&id=6f432c86&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f432c86"]])

export default __exports__